import * as React from "react"

import Theme from 'components/basics/theme/Theme'
import Button from 'components/forms/button/Button'

import * as st from './TryScope.styled.js'

const TryScope = () => (
  <Theme value="dark">
    <st.Wrap>
      <st.Content>
        <st.MessageBlock>
          <st.MessageWrap>
            <st.Title>Try Scope Now</st.Title>
            <st.Message>We'll guide you in organizing and automating customer onboarding, with recommendations to reduce delays and boost customer engagement</st.Message>
          </st.MessageWrap>
          <st.BookButton
            type="a"
            view="primary-color"
            size={800}
            eventName="book-demo"
            href="https://cal.com/scope/demo"
          >
            Book a Demo
          </st.BookButton>
        </st.MessageBlock>

        <st.ImageBlock>
          <img
            src="//cdn-platform.scope-dev.ws/website/images/illustrations/democall-v2.png"
            srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/democall-v2.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/democall-v2@2x.png 2x"
            width={292}
            height={271}
            alt="Try Scope - implementation platform for B2B customer onboarding"
          />
        </st.ImageBlock>
      </st.Content>
    </st.Wrap>
  </Theme>
)

export default TryScope
